const pendingBcrActionTypes = {
  GET_PENDING_BCR_APPROVALS_SUCCESS: "GET_PENDING_BCR_APPROVALS_SUCCESS",
  GET_PENDING_BCR_APPROVALS_FAILURE: "GET_PENDING_BCR_APPROVALS_FAILURE",
  APPROVE_REJECT_PENDING_BCR_SUCCESS: "APPROVE_REJECT_PENDING_BCR_SUCCESS",
  APPROVE_REJECT_PENDING_BCR_FAILURE: "APPROVE_REJECT_PENDING_BCR_FAILURE",
};

export default pendingBcrActionTypes;
